import cfg from '@/vue-caas/config/config.js';

/**
 * 로그인 완료 처리 (세션 hash 발급 이후). Login.vue 에 있던 성공 처리를 그대로 옮긴 것으로
 * Login.vue(OTP 비활성) 와 OtpVerify.vue(OTP 2단계 성공) 가 공통으로 사용한다.
 */
export default {
  methods: {
    completeLogin() {
      const hash = this.$store.getters['membership/hash'];
      // Cookie expired time unit
      // y: year
      // m: month
      // d: day
      // h: hour
      // min: minute
      // s: second
      // const expiredTime = '30s';
      const expiredTime = '12h';
      this.$cookies.set('hash', hash, expiredTime);
      this.$http.defaults.headers.common['hash'] = hash;
      return this.$store
        .dispatch('membership/getSessionInfo', { hash: this.$cookies.get('hash') })
        .then(() => {
          const sessionInfo = this.$store.getters['membership/sessioninfo'];
          // alert(`sessionInfo: ${JSON.stringify(sessionInfo)}`);
          // Add by April for DLB  2020.06.10
          this.$cookies.set('user-admin-yn', sessionInfo.sp_flg, expiredTime); // User권한 - Admin 권한을 가진 User인지 여부
          this.$cookies.set('comp-repo-use-yn', sessionInfo.comp_repo_use_flg, expiredTime); // Company권한 - Company용 Repository를 사용하는지 여부
          this.$cookies.set(
            'comp-adminrepo-use-yn',
            sessionInfo.comp_admin_repo_use_flg,
            expiredTime,
          ); // Company권한 - Company가 Admin Repository를 사용하는지 여부
          // 2023.10.11
          this.$cookies.set('user-admin-yn-origin', sessionInfo.sp_flg, expiredTime);
          this.$cookies.set(
            'comp-repo-use-yn-origin',
            sessionInfo.comp_repo_use_flg,
            expiredTime,
          );
          let comprepo = sessionInfo.comp_repo_use_flg + sessionInfo.comp_admin_repo_use_flg; // ex)YY, YN .. UserRepository사용여부, CLT Repository사용여부
          this.$cookies.set('match-used-repo', comprepo, expiredTime); // Matching을 돌릴때에는 CLT Repository를 사용하는 Customer에 대해서는 접근권한을 준다.  Added for DLB

          this.$cookies.set('ownr-id', sessionInfo.ownr_id, expiredTime); // Company정보 - Owner ID
          this.$cookies.set('comp-id', sessionInfo.comp_id, expiredTime); // Company정보 - Company ID
          this.$cookies.set('comp-name', sessionInfo.comp_nm, expiredTime); // Company정보 - Company Name
          this.$cookies.set('user-id', sessionInfo.usr_id, expiredTime); // User정보 - User ID

          this.$cookies.set('user-name', sessionInfo.usr_nm, expiredTime); // User정보 - User ID
          this.$cookies.set('ui-theme', sessionInfo.sel_ui_thm_cd, expiredTime); // User정보 - 선택 테마
          this.$cookies.set('gmt-timezone', sessionInfo.gmt_tmzn_cd, expiredTime); // User정보 - GMT 시간
          this.$cookies.set('date-format', sessionInfo.cnt_dt_fmt_cd, expiredTime); // User정보 - 날짜 포멧
          this.$cookies.set('country-code', sessionInfo.lang_tp_cd, expiredTime); // User정보 - 국가정보 (언어정보)
          this.$cookies.set('use-grade', sessionInfo.use_grd_cd, expiredTime); // User정보 - 사용자 등급
          this.$cookies.set('auth-token', 'N', expiredTime);

          const authList = [];

          this.$store
            .dispatch('getUser', { usrId: this.$cookies.get('user-id') })
            .then(() => {
              const menuListStr = this.$store.getters.user.menuAuth;
              const userCompId = this.$store.getters.user.compId;
              const menuList = JSON.parse(menuListStr);
              for (let i = 0; i < menuList.length; i += 1) {
                const tmpMenu = menuList[i];
                if (tmpMenu.select !== undefined) {
                  if (tmpMenu.select) {
                    authList.push({
                      h: tmpMenu.href,
                      s: tmpMenu.search,
                      m: tmpMenu.manage,
                    });
                  }
                } else {
                  const tmpParent = JSON.parse(JSON.stringify(tmpMenu));
                  tmpParent.children = [];

                  for (let j = 0; j < tmpMenu.children.length; j += 1) {
                    const tmpChild = tmpMenu.children[j];
                    if (tmpChild.select) {
                      authList.push({
                        h: tmpChild.href,
                        s: tmpChild.search,
                        m: tmpChild.manage,
                      });
                    }
                    if (tmpChild.children && tmpChild.children.length > 0) {
                      for (let k = 0; k < tmpChild.children.length; k += 1) {
                        const tmpGrandChild = tmpChild.children[k];

                        // level 3
                        if (tmpGrandChild.select) {
                          authList.push({
                            h: tmpGrandChild.href,
                            s: tmpGrandChild.search,
                            m: tmpGrandChild.manage,
                          });
                        }
                      }
                    }
                  }
                }
              }

              if (userCompId == cfg.provider) {
                comprepo = sessionInfo.comp_repo_use_flg + 'Y';
              } else {
                comprepo = sessionInfo.comp_repo_use_flg + 'N';
              }
              this.$cookies.set('used-repo', comprepo, expiredTime); // CLT Super Admin이 사용하는 화면들을 위해   Added for DLB
              this.$cookies.set('menu-auth', JSON.stringify(authList), expiredTime);
              this.$cookies.set('login-user-comp-id', userCompId, expiredTime);
              // alert('success');
              this.$router.push(this.$homePage);
              // 2021.3.25 203728 SPKA-57 issue 26
              Store.commit('common/setCompanyForLeftMenu', sessionInfo.comp_id);
              Store.commit('common/isDlb', cfg.isDlb);

              this.$store.dispatch('insertUserLoginHistory', { usrId: this.$cookies.get('user-id') });
            })
            .catch((err) => {
              // alert(`failure + ${err}`);
              this.$router.push(this.$homePage);
            });
        });
    },
  },
};
